import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import { useUpdateCustomReport } from './useUpdateCustomReport'

export type { UpdateCustomReportOptions } from './useUpdateCustomReport'

export const useCtxUpdateCustomReport = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useUpdateCustomReport(companyId)
}
